import '@/shared/csrf-token-deprecated';
import '~/css/shared/media-object.css';
import '~/css/shared/3d-models/comments.css';

import $ from '@/bundles/jquery';
import authPopupHandler from "@/shared/auth-popup-handler";

class CommentManager
{
    constructor(modelId, section) {
        this.modelId = modelId;

        this.section = section;
        this.$section = $(section);

        this.$loaderWrap = this.$section.find('.loader-wrap');
        this.$commentsWrap = this.$section.find('.comments-wrap');
    }

    init() {
        this.loadPage(1);
    }

    listen()
    {
        var self = this;

        this.$formNewComment = this.$section.find('#formComment');
        this.$formReply = this.$section.find('#formReply');
        this.$formDeleteComment = this.$section.find('#formDeleteComment');

        var focusTimer;

        self.$formNewComment.off('focusin').on('focusin', function() {
            if (focusTimer) {
                window.clearTimeout(focusTimer);
            }

            if (self.$formNewComment.find('textarea').hasClass('login-link')) {
                return false;
            }

            $(this).addClass('has-focus');
        }).off('focusout').on('focusout', function() {
            focusTimer = window.setTimeout(function() {
                self.$formNewComment.removeClass('has-focus');
            }, 50);
        });

        self.$section.find('.btn-comment-delete').off('click').on('click', function() {
            if (confirm('Are you sure want to delete this comment?')) {
                var id = $(this).data('id');
                self.$formDeleteComment.find('input[name="delete_comment"]').val(id);
                self.$formDeleteComment.submit();
            }

            return false;
        });

        self.$section.find('.btn-reply').off('click').on('click', function() {
            var $previousComment = self.$formReply.closest('.comment');

            if ($previousComment.length > 0) {
                $previousComment.find('.btn-reply').removeClass('d-none');
            }

            var $btnReply = $(this);
            $btnReply.addClass('d-none');

            var $comment = $(this).closest('.comment');
            self.$formReply.appendTo($comment).removeClass('d-none');

            var id = $(this).data('id');
            var $inputParent = self.$formReply.find('input[name="parent"]');
            $inputParent.val(id);

            var $btnCancel = self.$formReply.find('.btn-cancel');
            $btnCancel.off('click').on('click', function() {
                $btnReply.removeClass('d-none');
                self.$formReply.addClass('d-none');
            });

            var authorName = $(this).data('author');

            var $inputComment = self.$formReply.find('textarea');
            $inputComment.val('@'+authorName+' ');
            $inputComment.focus();
        });

        var $buttonsLike = self.$section.find('.btn-like');

        $buttonsLike.each(function() {
            var $btn = $(this);

            if ($btn.hasClass('active')) {
                $btn.attr('title', $btn.data('title-down'));
            } else {
                $btn.attr('title', $btn.data('title-up'));
            }
        });

        $buttonsLike.off('click').on('click', function() {
            var $btn = $(this);

            if ($btn.hasClass('loading')) {
                return false;
            }

            if ($btn.hasClass('login-link')) {
                authPopupHandler.showLoginPopup();
                return false;
            }

            var id = $btn.data('id');
            var isLiked = !!$btn.data('active');
            var $counter = $btn.siblings('.num-likes');
            var count = $counter.data('num');

            if (isLiked) {
                count--;
                $btn.data('active', 0);
                $btn.removeClass('btn-info').addClass('btn-default');
                $btn.attr('title', $btn.data('title-up'));
            } else {
                count++;
                $btn.data('active', 1);
                $btn.removeClass('btn-default').addClass('btn-info');
                $btn.attr('title', $btn.data('title-down'));
            }

            $counter.data('num', count);
            $counter.text(count.format(0, '.', ','));

            $btn.addClass('loading');

            $.ajaxCsrf(window.location.href, {
                method: "post",
                data: {
                    comment_id: id,
                    comment_like: isLiked ? 0 : 1
                },
                error: function(xhr) {
                    if (xhr.status === 403) {
                        authPopupHandler.showLoginPopup();
                    }
                },
                complete: function() {
                    $btn.removeClass('loading');
                }
            });

            this.blur();

            return false;
        });

        var $pagination = self.$section.find('.pagination');

        if ($pagination.length > 0) {
            $pagination.find('a').on('click', function() {
                var href = $(this).attr('href');
                var match = href.match(/^#p(\d+)$/);

                if (match) {
                    self.loadPage(match[1]);
                    return false;
                }
            });
        }
    }

    loadPage(pageNum)
    {
        var self = this;

        self.$commentsWrap.html('');
        self.$loaderWrap.removeClass('d-none');

        $.ajax('/3d-models/'+this.modelId+'/comments', {
            method: 'GET',
            data: {
                p: pageNum,
            }
        }).then(function(response) {
            self.$loaderWrap.addClass('d-none');
            self.$commentsWrap.html(response);
            self.listen();
        });
    }
}

export default CommentManager;
